import { render, staticRenderFns } from "./LicenseInfoEdit.vue?vue&type=template&id=21caf3bf"
import script from "./LicenseInfoEdit.vue?vue&type=script&lang=js"
export * from "./LicenseInfoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports